import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

function NewProgress({ kqRating }) {
  // Convert the rating from 5 to 10 scale
  const percentage = kqRating ? (kqRating * 2).toFixed(1) : '0.0';

  return (
    <>
      {percentage && (
        <div style={{ width: 125, height: 125 }}>
          <CircularProgressbar
            value={percentage}
            text={`${percentage}`}
            maxValue={10}
            minValue={0}
            background={true}
            styles={{
              path: {
                stroke: 'var(--secondary)',
              },
              trail: {
                stroke: 'var(--faded)',
              },
              text: {
                fill: 'var(--secondary)',
                fontSize: '2rem',
                fontWeight: 'normal',
                fontFamily: 'montserrat',
              },
              background: {
                fill: 'var(--primary)',
              },
            }}
          />
        </div>
      )}
    </>
  );
}

export default NewProgress;
